var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rows.length != undefined && _vm.rows.length > 0 && _vm.rows.length != null)?_c('div',[_c('div',{staticClass:"bg-white data-table p-0"},[_c('vue-good-table',{ref:"listAssetTable",attrs:{"mode":"remote","title":"Assets","totalRows":_vm.totalRecords,"columns":_vm.columns,"rows":_vm.rows,"pagination-options":{
                enabled: true,
                position: 'bottom',
                perPage: _vm.perPage,
                perPageDropdown:_vm.dropDownPerPage,
                dropdownAllowAll: false,
            }},on:{"on-page-change":_vm.onPageChange,"on-column-filter":_vm.onColumnFilter,"on-per-page-change":_vm.onPerPageChange,"on-sort-change":_vm.onSortChange}})],1)]):_c('div',[_c('span',[_vm._v("No data Found")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab38c184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/RepairOrderList.vue
// module id = null
// module chunks = 